import { useQuery } from '@apollo/client';
import { GET_USER_FIELDS, type UserFieldsQuery } from '../graphql/queries';

export const useUserFields = () => useQuery<UserFieldsQuery>(GET_USER_FIELDS);
